import React from "react";
import { Link } from "@mui/material";
import { styled } from "@mui/material/styles";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";

const SocialLinks = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  marginLeft: theme.spacing(1),
  justifyContent: "space-evenly",
  display: "flex",
  flexDirection: "row",
}));

function SocialIcons() {
  return (
    <SocialLinks>
      <Link
        href="https://www.facebook.com/dusha.halkidiki/"
        color="inherit"
        target="_blank"
      >
        <FacebookIcon fontSize="large" />
      </Link>
      <Link
        href="https://www.instagram.com/dusha.halkidiki/?fbclid=IwZXh0bgNhZW0CMTAAAR3p1YFMU_aclvnjVhYLQXerrtfvpt9iugpJGU8Jv88VEHuTsTPHAqJl_Lg_aem_ASv9ReEapzINU-O7744M67uWOlMyczQILtWhdO9NUp9PS4tgZEVl15h8cUNtqlNMA525dSyFNwaxUKmApZ00kRQQ"
        color="inherit"
        target="_blank"
      >
        <InstagramIcon fontSize="large" />
      </Link>
    </SocialLinks>
  );
}

export default SocialIcons;
